import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { THEME_COLOR, THEME_COLOR3, THEME_COLOR4 } from '../../../../../constants';
import type { TAllergen } from '../schemas';

type TAllergenChipGridProps = {
  allergens: TAllergen[];
  value: string[];
  onChange: (ids: string[]) => void;
};

const AllergenChipGrid = ({ allergens, value, onChange }: TAllergenChipGridProps) => {
  const toggle = (id: string) => {
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  };

  if (!allergens.length) {
    return (
      <Typography sx={{ fontSize: 12, fontFamily: 'GilroyRegular', color: THEME_COLOR3 }}>
        No allergens configured.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {allergens.map((allergen) => {
        const selected = value.includes(allergen._id);
        const asset = allergen.icon || allergen.image;
        return (
          <Box
            key={allergen._id}
            component="button"
            type="button"
            onClick={() => toggle(allergen._id)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
              px: 1.5,
              py: 0.75,
              borderRadius: '999px',
              border: `1px solid ${selected ? '#f59e0b' : THEME_COLOR4}`,
              backgroundColor: selected ? '#fef3c7' : '#FFF',
              cursor: 'pointer',
              appearance: 'none',
              font: 'inherit',
              transition: 'background-color 0.15s, border-color 0.15s',
              '&:hover': {
                borderColor: '#f59e0b',
                backgroundColor: selected ? '#fef3c7' : '#fffbeb',
              },
            }}
          >
            {asset && (
              <Box
                component="img"
                src={asset}
                alt=""
                sx={{ width: 14, height: 14, objectFit: 'contain', flexShrink: 0 }}
              />
            )}
            <Typography
              sx={{
                fontSize: 12,
                fontFamily: selected ? 'GilroySemiBold' : 'GilroyRegular',
                color: selected ? '#92400e' : '#000',
                lineHeight: 1,
              }}
            >
              {allergen.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default AllergenChipGrid;
